<template>
  <div class="upload-photo" @click="$upload.select('upload-photo')" v-bind:style="{ backgroundImage: preview ? 'url('+ preview +')' : false }">
    <span v-if="$upload.meta('upload-photo').percentComplete > 0" class="upload-photo__progress" v-bind:style="{ height: 100 - $upload.meta('upload-photo').percentComplete + '%' }"></span>
  </div>
</template>

<script>
import EXIF from 'exif-js';
import resetOrientation from '../../helpers/image-orientation-helpers';

export default {
  props: {
    url: { type: String, required: true },
    preview: { type: String, required: false, default: ''},
  },
  data() {
    return {
      value: null,
    }
  },
  created() {
    this.$upload.new('upload-photo', {
      maxSizePerFile: 50000,
      onSuccess(res) {
        this.$emit('input', res.body.upload.identifier);
      },
      onError() {
        this.$emit('error');
      },
      onSelect(files) {
        this.$emit('picture-selected', files[0]);
        files[0].preview((file) => {
          const self = this;
          EXIF.getData(file.$file, function () {
            const orientation = EXIF.getTag(this, 'Orientation');
            resetOrientation(file.raw, orientation, (resetBase64Image) => {
              self.$emit('change-preview', resetBase64Image);
            });
          });
        });
      },
    });
  },
  mounted() {
    this.$upload.reset('upload-photo', {
      url: this.url,
    });
  },
}
</script>
